"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useContentCellPropertiesWithoutLabel = function () {
    var contentCellPropertiesWithoutLabel = (0, react_1.useMemo)(function () {
        var cellProperties = Object.create(null);
        cellProperties.align = 'left';
        cellProperties.colSpan = 2;
        return cellProperties;
    }, []);
    return contentCellPropertiesWithoutLabel;
};
exports.default = useContentCellPropertiesWithoutLabel;
